import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PastMeetingNotes from "../../components/PastMeetingNotes/PastMeetingNotes";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import CardTask from "../TasksPage/CardTask";
import PastTranscript from "../../components/PastTranscript/PastTranscript";
import { theme } from "../../utils/theme";
// import { httpsCallable } from "firebase/functions";
import { db } from "../../config/firebase-config";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
// import { doc, getDoc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import CalendarMeetingCard from "../Meetings/CalendarMeetingCard";
import dayjs from "dayjs";
import AdhocMeetingCard from "../Meetings/AdhocMeetingCard";
import gcal from "../../images/google_calendar.png";
import mcal from "../../images/microsoft_calendar.png";
import {
  getCalendarVerificationLinkMS,
  getCalendarVerificationLink,
} from "../../functions";
import { partialUpdateUser, getCurrentUser, fetchUserData } from "../../services/UserService"
import { createUserCalendarMeetings, fetchCalendarMeetings, fetchCalendarBotMeetings } from "../../services/UserCalendarMeetingService"
import { fetchBotMeetings } from "../../services/UserBotMeetingService"
import { fetchMeetings } from "../../services/MeetingService"

// import { setNewUser } from "../../redux/actions/authActions";

import {
  addDoc,
  getDoc,
  collection,
  onSnapshot,
  doc,
  updateDoc,
  setDoc,
} from "firebase/firestore";

const HomePage = () => {
  const stripeApiKey = process.env.REACT_APP_STRIPE_API_KEY;
  const { userData } = useSelector((state) => state.authReducer);
  const { isNewUser } = useSelector((state) => state.authReducer);
  const { uploads } = useSelector((state) => state.uploadsReducer);
  const { meetings, calendarMeetings, calendarBotMeetings } = useSelector(
    (state) => state.meetingsReducer
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [calendar, setCalendar] = useState(false);
  const [tasksData, setTasksData] = useState();

  const [calendarAuthLoading, setCalendarAuthLoading] = useState(false);
  const [calendarAuthLoadingMs, setCalendarAuthLoadingMs] = useState(false);
  const auth = getAuth();
  const [modifiedUploads, setModifiedUploads] = useState();
  const [upcomingMeetings, setUpcomingMeetings] = useState(0);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [date, setDate] = useState(dayjs(new Date()));

  const addMeetChecker = async () => {
    const meetTimeChecker = {
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    try {
      // Assuming you have a reference to your Firestore database (db)
      let user = getCurrentUser();
      partialUpdateUser(user.uid, { meetTimeChecker })

      // const userDocRef = doc(db, `users/${localStorage.getItem("@auth")}`); // Replace userId with the actual user ID

      // // Listen for changes on the user document
      // const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      //   if (docSnapshot.exists()) {
      //     setDoc(userDocRef, { meetTimeChecker }, { merge: true });
      //     console.log("MeetTimeChecker added to Firestore");
      //     unsubscribe();
      //   }
      // });
    } catch (error) {
      console.error("Error adding MeetTimeChecker to Firestore: ", error);
    }
  };
  const addSubscription = async () => {
    const subscriptionData = {
      subscription: {
        free: {
          languages: ["english"],
          recordLimit: 3,
          timeLimit: 120,
        },
      },
    };

    try {
      let user = getCurrentUser();
      partialUpdateUser(user.uid, { ...subscriptionData })

      // const userDocRef = doc(db, `users/${localStorage.getItem("@auth")}`); // Replace userId with the actual user ID

      // // Listen for changes on the user document
      // const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      //   if (docSnapshot.exists()) {
      //     setDoc(userDocRef, { ...subscriptionData }, { merge: true });
      //     console.log("Subscription data added to Firestore");
      //     unsubscribe();
      //   }
      // });
    } catch (error) {
      console.error("Error adding subscription data to Firestore: ", error);
    }
  };

  //adding dummyData - start
  useEffect(() => {
    console.log("isNewUser: ", isNewUser);
    if (isNewUser) {
      console.log("New User Dummy Data !");
      // addDummyData();
      // addMeetChecker();
      // addSubscription();
    }
    fetchCalendarMeetings(dispatch);
    fetchBotMeetings(dispatch);
    fetchMeetings(dispatch);
    fetchCalendarBotMeetings(dispatch);
  }, []);

  // Dummy Meet - Start
  const addDummyData = async () => {
    const historyData1 = {
      code: "ready",
      createdAt: new Date(),
    };

    const historyData2 = {
      code: "joining_call",
      createdAt: new Date(),
    };

    const historyData3 = {
      code: "in_waiting_room",
      createdAt: new Date(),
    };
    const historyData4 = {
      code: "in_call_not_recording",
      createdAt: new Date(),
    };
    const historyData5 = {
      code: "in_call_recording",
      createdAt: new Date(),
    };
    const historyData6 = {
      code: "call_ended",
      createdAt: new Date(),
    };
    const historyData7 = {
      code: "done",
      createdAt: new Date(),
    };
    const dummyBotStatus = {
      history: [
        historyData1,
        historyData2,
        historyData3,
        historyData4,
        historyData5,
        historyData6,
        historyData7,
      ],
      status: "done",
    };
    const dummyMeeting = {
      name: "The is a Dummy Meet",
      attendees: ["User1", "User2"],
      attendeeEmails: ["user1@example.com", "user2@example.com"],
      botId: "bot123",
      startTime: new Date(),
      endTime: new Date(),
      willRecord: true,
      meetInvite: { meetId: "meeting123" },
      calendarMeetId: "CalendarMeetID-12345",
      icalUid: "icalUid-111000",
      hashTag: "#calendarMeet",
      language: "english",
      favourite: false,
      meetingPlatform: "MeetMinutes",
      botStats: dummyBotStatus,
      summary:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
      notes: [
        { completed: false, name: "Dummy note 1" },
        { completed: false, name: "Dummy note 2" },
      ],
      questions: [
        { completed: false, name: "Dummy question 1" },
        { completed: false, name: "Dummy question 2" },
      ],
      tasks: [
        { completed: false, name: "Dummy task 1" },
        { completed: false, name: "Dummy task 2" },
      ],
      tasksForOthers: [
        { completed: false, name: "Dummy task for others 1" },
        { completed: false, name: "Dummy task for others 2" },
      ],
    };
    try {
      // Add the dummy data to Firestore
      await addNewMeetToFirebase(dummyMeeting);

      console.log("Dummy Data Added Successfully!");
    } catch (error) {
      console.error("Error adding dummy data:", error);
    }
  };

  const addNewMeetToFirebase = async (newDoc) => {
    let user = getCurrentUser();
    return await createUserCalendarMeetings(user.uid, newDoc);
  };
  // Dummy Meet - End

  //number of upcoming meetings today

  useEffect(() => {
    let x = 0;
    if (
      calendarMeetings?.detail !== "Invalid token" &&
      calendarMeetings !== null
    )
      calendarMeetings?.forEach((meet, idx) => {
        if (
          meet?.startTime &&
          moment().format("YYYYMMDD") ===
            moment(moment(meet?.startTime)?.toDate()).format("YYYYMMDD") &&
          moment().format("YYYYMMDDHHmmss") <
            moment(moment(meet?.endTime)?.toDate()).format("YYYYMMDDHHmmss")
        )
          x++;
      });
    setUpcomingMeetings(x);
  }, [calendarMeetings]);

  //
  //
  //only one meetings tasks are shown on home page
  const fetchPastTasks = useCallback(async () => {
    let arr = [];
    uploads?.forEach((upload, idx) => {
      let participant;
      try {
        participant = Object.entries(upload.participants)[0][0];
      } catch (err) {
        // console.log(err);
      }
      if (participant && upload?.participants[participant]?.tasks.length > 0) {
        let taskPresent = false;
        upload?.participants[participant]?.tasks.forEach((task) => {
          if (!task.taskDeleted && !task.completed) {
            taskPresent = true;
          }
        });
        if (taskPresent)
          arr.push({
            ...upload,
            idx: idx,
            taskType: "uploads",
            tasks: upload?.participants[participant]?.tasks?.map((item) => {
              if (item?.name) return item;
              else
                return {
                  name: item?.name ? item.name : item,
                  completed: item?.completed ? item.completed : false,
                  taskDone: item?.taskDone ? item.taskDone : false,
                  taskDeleted: item?.taskDeleted ? item.taskDeleted : false,
                };
            }),
            tasksForOthers: upload?.participants[
              participant
            ]?.tasksForOthers.map((item) => {
              return {
                name: item?.name ? item.name : item,
                completed: item?.completed ? item.completed : false,
              };
            }),
            participant: participant,
          });
      }
    });
    meetings?.forEach((meeting, idx) => {
      if (meeting?.tasks && meeting?.tasks?.length > 0) {
        let taskPresent = false;
        meeting?.tasks?.forEach((task) => {
          if (!task.taskDeleted && !task.completed) {
            taskPresent = true;
          }
        });
        if (taskPresent)
          arr.push({
            ...meeting,
            taskType: "botMeetings",
            idx: idx,
          });
      }
    });
    calendarMeetings &&
      calendarMeetings?.detail !== "Invalid token" &&
      calendarMeetings?.forEach((meet, idx) => {
        if (meet?.tasks && meet?.tasks?.length > 0) {
          let taskPresent = false;
          meet?.tasks?.forEach((task) => {
            if (!task.taskDeleted && !task.completed) {
              taskPresent = true;
            }
          });
          if (taskPresent) {
            meet.createdAt = moment(meet.createdAt);
            arr.push({
              ...meet,
              taskType: "calendarMeetings",
              idx: idx,
            });
          }
        }
      });

    arr.sort((a, b) =>
      parseInt(moment(moment(a.createdAt)?.toDate()).format("YYYYMMDDHHmmss")) -
        parseInt(moment(moment(b.createdAt)?.toDate()).format("YYYYMMDDHHmmss")) >
      0
        ? -1
        : 1
    );
    setTasksData(arr[0]);
  }, [uploads, meetings, calendarMeetings]);

  useEffect(() => {
    fetchPastTasks();
  }, [uploads, meetings, fetchPastTasks, calendarMeetings]);

  //uploads are modified because by default the insights are set as [string] but we want other fields like completed, taskDone, taskDeleted, transName etc. so the insights except summary have to to be converted to array of objects this problem has been avoided in case of botMeetings/calendarMeetings
  useEffect(() => {
    let arr = [];
    uploads?.forEach((upload) => {
      let participant;
      try {
        participant = Object.entries(upload.participants)[0][0];
        // console.log(participant,"iuawdabscn");
      } catch (err) {
        // console.log(err,"error");
      }
      // console.log(participant,"participant");
      if (participant)
        arr.push({
          ...upload,
          tasks: upload.participants[participant].tasks.map((item) => {
            if (item?.name) return item;
            else
              return {
                name: item?.name ? item.name : item,
                completed: item?.completed ? item.completed : false,
                transName: item?.transName ? item.transName : "",
              };
          }),
          tasksForOthers: upload.participants[participant].tasksForOthers.map(
            (item) => {
              if (item?.name) return item;
              else
                return {
                  name: item?.name ? item.name : item,
                  completed: item?.completed ? item.completed : false,
                  transName: item?.transName ? item.transName : "",
                };
            }
          ),
          participant: participant,
        });
    });
    setModifiedUploads(arr);
  }, [uploads]);

  // console.log(moment(new Date(date)).format("YYYY-MM-DD"));
  const CalendarComponent = (
    <div className="bg-[#f5f8ff] rounded-2xl fade pb-[10px]">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          value={date}
          onChange={(newVal) => {
            setDate(newVal);
          }}
        />
      </LocalizationProvider>
      {calendarMeetings && calendarMeetings?.length > 0 && (
        <div className="my-[10px] px-[10px] lg:px-[20px] ">
          <div className="font-medium flex items-center justify-between 2xl:text-lg md:text-base text-sm ">
            <span>Meetings</span>
            <span
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "instant" });
                navigate("/meetings");
              }}
              className="text-[#1d7d81] cursor-pointer"
            >
              View All
            </span>
          </div>
          {calendarMeetings?.map((meet, idx) => {
            meet.endTime = moment(meet?.endTime);
            if (
              moment(new Date(date)).format("YYYYMMDD") ===
                moment(moment(meet?.startTime)?.toDate()).format("YYYYMMDD") &&
              meet?.calendarMeetId
            )
              return (
                <div
                  key={idx}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "instant" });
                    navigate(
                      `/meetings?meet=${meet?.id}${
                        meet?.endTime &&
                        moment().format("YYYYMMDDHHmmss") >
                          moment(moment(meet?.endTime)?.toDate()).format(
                            "YYYYMMDDHHmmss"
                          )
                          ? "&past=true"
                          : ""
                      }`
                    );
                  }}
                  className="bg-[#f0f4f7] flex cursor-pointer hover:shadow-md transition items-center gap-[10px] font-medium rounded-lg p-[10px] my-[10px] text-xs sm:text-sm 2xl:text-base"
                >
                  <img
                    src={auth?.currentUser?.photoURL}
                    className="w-[30px] h-[30px] rounded-full "
                    alt=""
                  />

                  <div className="flex-grow">
                    <div>{meet?.name}</div>
                    {meet?.startTime && (
                      <div className="text-gray-500">
                        {moment(moment(meet?.startTime)?.toDate()).format(
                          "DD MMM, YY | hh:mm A"
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
          })}
        </div>
      )}
    </div>
  );

  return (
    <div className="md:flex md:gap-[30px] md:items-start mr-[10px] lg:mr-0 ">
      {/* {showPopup && userData?.defaultLanguage && <Popup onClose={closePopup} />} */}
      <div className="flex-grow">
        <div className="flex justify-between items-center">
          <div className="flex gap-[5px] sm:flex-row flex-col justify-center capitalize lg:text-3xl text-xl font-medium">
            {userData?.name ? (
              <div className="flex gap-[5px] flex-wrap">
                <div className="">Welcome</div>
                <div>{userData.name}!</div>
              </div>
            ) : (
              <div className="">Welcome!</div>
            )}
          </div>
          <div
            onClick={() => setCalendar(!calendar)}
            className=" md:text-lg text-sm text-[#1d7d81] font-medium cursor-pointer transition lg:hidden flow-root"
          >
            {calendar ? (
              <RxCross2 className="h-[30px] w-[30px] text-[red]" />
            ) : (
              "View Calendar"
            )}
          </div>
        </div>

        <div className="text-[#6b7b8a] my-[5px]">
          Never miss a minute with MeetMinutes!
        </div>
        {calendarMeetings?.detail !== "Invalid token" &&
          calendarMeetings !== null && (
            <div
              className="my-[5px] cursor-pointer w-fit"
              onClick={() => {
                navigate("/meetings");
              }}
            >
              You have{" "}
              <span style={{ color: theme.color }} className="font-medium">
                {upcomingMeetings || 0} upcoming meeting(s) today
              </span>
            </div>
          )}
        {calendar && (
          <div className="lg:hidden flow-root  w-full lg:w-[33%]">
            {CalendarComponent}
          </div>
        )}
        <div className="border-b-[1px] my-[15px]"></div>
        {calendarMeetings?.detail === "Invalid token" && (
          <div className="my-[15px]">
            <div className="lg:text-lg text-sm xl:text-xl 2xl:text-2xl font-medium">
              Sync Your Calendar
            </div>
            <div className="text-[#757575] my-[10px] text-[15px]">
              Syncing your calendar with the meeting minutes can help you stay
              on top of your schedule and ensure that you follow up on action
              items and deadlines discussed during the meeting
            </div>
            <div
              onClick={() => {
                setCalendarAuthLoading(true);
                fetchUserData(dispatch);
                getCalendarVerificationLink({
                  user_id: localStorage.getItem("@auth"),
                })
                .then((res) => {
                  window.open(res.auth_url);
                })
                .catch(() => {
                  toast.error("Some error occured, please try later!");
                })
                .finally(() => {
                  setCalendarAuthLoading(false);
                });
              }}
              // style={{ backgroundColor: theme.color }}
              className="text-black rounded-md px-[15px] w-fit py-[10px] flex items-center justify-center cursor-pointer border-2 hover:border-[#07457F]"
            >
              {calendarAuthLoading ? (
                <CircularProgress
                  style={{ color: "white", width: "20px", height: "20px" }}
                />
              ) : (
                "Sync Now"
              )}
            </div>
          </div>
        )}
        {calendarMeetings && calendarMeetings?.length === 0 && (
          <div className="my-[15px]">
            <div className="text-sm xl:text-base 2xl:text-lg font-medium">
              Haven't synced your calendar yet?
            </div>
            <div className="text-[#757575] my-[10px] text-xs xl:text-sm 2xl:text-base">
              Incase you have some scheduled meetings in your calendar and you
              don't see them here, it might be because you haven't given us the
              necessary permissions. If you have already synced ignore this,
              meetings would appear once you add them in your calendar.
            </div>
            <div
              onClick={() => {
                setCalendarAuthLoading(true);
                fetchUserData(dispatch);
                getCalendarVerificationLink({
                  user_id: localStorage.getItem("@auth")
                })
                .then((res) => {
                  window.open(res.auth_url);
                })
                .catch(() => {
                  toast.error("Some error occured, please try later!");
                })
                .finally(() => {
                  setCalendarAuthLoading(false);
                });
              }}
              // style={{ backgroundColor: theme.color }}
              className="text-black rounded-md px-[15px] w-fit py-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
            >
              {calendarAuthLoading ? (
                <CircularProgress
                  style={{ color: "white", width: "20px", height: "20px" }}
                />
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img className="w-[35px]" src={gcal} alt="Calendar" />
                  <span style={{ marginLeft: "8px" }}>
                    Connect Google Calendar
                  </span>
                </div>
              )}
            </div>
            <div
              onClick={() => {
                setCalendarAuthLoadingMs(true);
                fetchUserData(dispatch);
                getCalendarVerificationLinkMS({
                  user_id: localStorage.getItem("@auth")
                })
                .then((res) => {
                  window.open(res.auth_url);
                })
                .catch(() => {
                  toast.error("Some error occured, please try later!");
                })
                .finally(() => {
                  setCalendarAuthLoadingMs(false);
                });
              }}
              // style={{ backgroundColor: theme.color }}
              className="text-black mt-[10px] rounded-md px-[15px] w-fit py-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
            >
              {calendarAuthLoadingMs ? (
                <CircularProgress
                  style={{ color: "white", width: "20px", height: "20px" }}
                />
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img className="w-[20px]" src={mcal} alt="Calendar" />
                  <span style={{ marginLeft: "8px" }}>
                    Connect Microsoft Calendar
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="my-[15px] s7-step">
          <div className="flex justify-between items-center">
            <div className="lg:text-lg text-sm xl:text-xl 2xl:text-2xl font-medium">
              Tasks For You
            </div>
            <div
              onClick={() => {
                navigate("/task");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="md:text-lg text-sm text-[#1d7d81] font-medium cursor-pointer"
            >
              View all
            </div>
          </div>
          <div className="fade">
            {tasksData?.tasks?.map((task, idx) => {
              if (!task.taskDeleted && !task.completed)
                return (
                  <CardTask
                    key={idx}
                    group={tasksData}
                    data={task}
                    idx={idx}
                    completed={task.taskDone}
                  />
                );
              return "";
            })}
          </div>
        </div>

        <div className="my-[15px]">
          <div className="flex justify-between items-center">
            <div className="lg:text-lg text-sm xl:text-xl 2xl:text-2xl font-medium">
              Past Uploads
            </div>
            <div
              onClick={() => {
                navigate("/uploads?past");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="md:text-lg text-sm text-[#1d7d81] font-medium cursor-pointer"
            >
              View all
            </div>
          </div>
          <PastMeetingNotes />
        </div>

        <div className="my-[15px]">
          <div className="flex justify-between items-center">
            <div className="lg:text-lg text-sm xl:text-xl 2xl:text-2xl font-medium">
              Important
            </div>
          </div>
          {
          // meetings
          //   ?.map((data, idx) => {
          //     if (data?.favourite)
          //       return (
          //         <AdhocMeetingCard data={data} key={data?.id} idx={idx} />
          //       );
          //   })
          //   .concat(
          //     modifiedUploads?.map((data, idx) => {
          //       if (data?.favourite)
          //         return (
          //           <PastTranscript
          //             key={data?.id}
          //             idx={idx}
          //             data={data}
          //             setOpenedTranscript={(props) => {}}
          //             openedTranscript={null}
          //           />
          //         );
          //     })
          //   )
              calendarBotMeetings?.map((data, idx) => {
                  let ref = data?.ref || "";
                  if (ref == "calendarMeetings" && (moment().format("YYYYMMDDHHmmss") > moment(moment(data?.createdAt)?.toDate()).format("YYYYMMDDHHmmss"))){
                    return (
                      <CalendarMeetingCard
                        data={data}
                        key={data?.calendarMeetId || idx}
                        idx={idx}
                        pastMeeting
                      />
                    );
                  }else if (ref == "botMeetings"){
                    return (
                      <AdhocMeetingCard data={data} key={data?.id} idx={idx} />
                    );
                  }else if (ref.indexOf("meetings") != -1){
                    return (
                      <PastTranscript
                        key={data?.id}
                        idx={idx}
                        data={data}
                        setOpenedTranscript={(props) => {}}
                        openedTranscript={null}
                      />
                    );
                  }
              })
            }
        </div>
      </div>

      <div className="lg:flow-root hidden w-full lg:w-[40%] xl:w-[33%] s8-step">
        {CalendarComponent}
      </div>
    </div>
  );
};

export default HomePage;
{
  /*

subscriptuion:{
  productivity pro:{
    languages:[english,hindi,french],
    periodEnd:1698909169,
    periodEnd:1696230769,
    timeLimit:3000,
    recordLimit:30,
  }
}


end: 1699087070

*/
}
//
